import { body, toTop } from "../elements";
import {
  asyncForEach,
  make_elements_tabbable,
  make_elements_untabbable,
  wait,
} from "../lib/helpers";

export function useNavbar() {
  // Navbar
  function Navbar(nb) {
    if (!(nb instanceof Element)) return;

    const toggle = nb.querySelector(".toggle");
    // const menu_wrap = nb.querySelector(".navbar__menu-wrap");
    const menu = nb.querySelector(".navbar__menu");
    const menu_items = nb.querySelectorAll(".navbar__menu-item--level-1");
    const nav_items = nb.querySelectorAll(".navbar__nav-item--level-1");
    const social_menu = nb.querySelector(".navbar__social-menu");
    const sub_wraps = nb.querySelectorAll(".menu-item-has-children");
    const newsletter_link = nb.querySelector(".navbar__newsletter-btn");
    const search_btn = nb.querySelector(".navbar__search-btn");
    const search_dialog = nb.querySelector(".navbar__search");
    const search_close = nb.querySelector(".navbar__search-close");

    function getSubWrapElements(sub_wrap) {
      const btn = sub_wrap.querySelector(".navbar__sub-toggle");
      const back_btn = sub_wrap.querySelector(".navbar__back-btn");
      const sub_menu = sub_wrap.querySelector(".navbar__sub-menu");
      const sub_menu_items = sub_menu.querySelectorAll(".navbar__menu-item");
      const sub_nav_links = sub_menu.querySelectorAll(".navbar__nav-item");

      const sub_focusable_elements = [back_btn, ...sub_nav_links];

      return {
        btn,
        back_btn,
        sub_menu,
        sub_menu_items,
        sub_nav_links,
        sub_focusable_elements,
      };
    }

    function closeSubNav(sub_wrap) {
      const { btn, sub_menu, sub_menu_items, sub_focusable_elements } =
        getSubWrapElements(sub_wrap);

      btn.setAttribute("aria-expanded", "false");
      sub_menu.setAttribute("aria-expanded", "false");
      sub_wrap.classList.remove("open");
      make_elements_tabbable(sub_focusable_elements);
      sub_menu_items.forEach((item) => item.classList.add("out"));
    }

    function closeAllSubNavs() {
      sub_wraps.forEach((sub) => {
        closeSubNav(sub);
      });
    }

    closeAllSubNavs();

    function openSubNav(sub_wrap) {
      closeAllSubNavs();

      const { btn, sub_menu, sub_menu_items, sub_focusable_elements } =
        getSubWrapElements(sub_wrap);

      btn.setAttribute("aria-expanded", "true");
      sub_menu.setAttribute("aria-expanded", "true");
      sub_wrap.classList.add("open");
      make_elements_untabbable(sub_focusable_elements);
      asyncForEach(sub_menu_items, async (item) => {
        await wait(100);
        item.classList.remove("out");
      });
    }

    sub_wraps.forEach((sub_wrap) => {
      const { btn, back_btn } = getSubWrapElements(sub_wrap);

      btn &&
        btn.addEventListener("click", () => {
          if (btn.getAttribute("aria-expanded") === "false") {
            openSubNav(sub_wrap);
          } else {
            closeSubNav(sub_wrap);
          }
        });

      back_btn &&
        back_btn.addEventListener("click", () => {
          closeSubNav(sub_wrap);
          btn.focus();
        });
    });

    async function openNavbar() {
      body.classList.add("navbar-open");
      nb.classList.add("transition-in");
      await wait(200);
      nb.classList.add("open");
      nb.classList.remove("transition-in");
      await wait(100);
      asyncForEach(menu_items, async (item) => {
        await wait(100);
        item.classList.remove("out");
      });
    }

    async function closeNavbar() {
      nb.classList.add("transition-out");
      nb.classList.remove("open");
      closeAllSubNavs();
      await wait(200);
      nb.classList.remove("transition-out");
      body.classList.remove("navbar-open");
      menu_items.forEach((item) => {
        item.classList.add("out");
      });
    }

    function toggleNavbar() {
      if (nb.classList.contains("open")) {
        closeNavbar();
      } else {
        openNavbar();
      }
    }

    function stickyNavSetUp() {
      const socialHeight = social_menu.offsetHeight;
      nb.style.setProperty("--social-height", `${socialHeight}px`);
    }

    stickyNavSetUp();

    async function stickyNav() {
      if (window.scrollY > social_menu.offsetHeight) {
        nb.classList.add("sticky");
        toTop.classList.add("visible");
      } else {
        nb.classList.remove("sticky");
        toTop.classList.remove("visible");
      }
    }

    stickyNav();

    window.addEventListener("scroll", stickyNav);

    toggle.addEventListener("click", toggleNavbar);
    newsletter_link.addEventListener("click", closeNavbar);

    nb.style.setProperty("--menu-height-desktop", `${menu.offsetHeight}px`);

    const navMenuResizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        nb.style.setProperty("--menu-height-desktop", `${menu.offsetHeight}px`);
      }
    });
    navMenuResizeObserver.observe(body);

    function openSearchModal() {
      search_dialog.showModal();
    }

    function closeSearchModal() {
      search_dialog.close();
    }

    search_btn.addEventListener("click", openSearchModal);
    search_close.addEventListener("click", closeSearchModal);
  }

  const navbar = document.querySelector(".navbar");

  navbar && Navbar(navbar);
}
